import common from './common'

function inputRetention(obj) {
    //入力保持
    obj.item = common.getStore(obj, 'smallItems')
    // 「大型」表示品目数
    obj.largeView = common.getStore(obj, 'largeItems').length
    // 「中型」表示品目数
    obj.mediumView = common.countMediumView(obj)
    // 選択した中型箱数
    obj.mediumCounts = common.getStore(obj, 'medium_box_cnt')
    obj.smallTag = common.getStore(obj, 'smallTag')
    obj.numOfSmallItemsTag = common.getStore(obj, 'numOfSmallItemsTag')
    // 価格設定が一律の場合
    if (obj.siteCodeInfo[0].PRICING_METHOD == 1) {
        obj.item.maxQuantity = common.constant.MAXQUANTITY_SMALL + obj.mediumCounts
        if (obj.item.quantityFlg) {
            let newArray = []
            for (let i = obj.mediumCounts + 2; i <= obj.item.maxQuantity; i++) {
                newArray.push(i)
            }
            obj.item.numArray = newArray
        }
    }

    let url = common.constant.GET_FEE_URL
    // レスポンス処理
    let func = (response) => {
        obj.item.fee = response.data.small_items[0]['FEE']
        obj.item.fee_inc_tax = common.includingTax(response.data.small_items[0]['FEE'], response.data.sales_tax_rate)
    }

    let params = {
        yubin: common.getStore(obj, 'addressFormSelected').YUBIN.replace('-', ''),
        site_code: process.env.VUE_APP_SITE_CODE,
        large_items: [],
        medium_items: [],
        small_items: [{
            'item': obj.item.code,
        }],
    }
    common.executeAxiosPost(url, func, params, obj)
}

function createNumArray(obj, start) {
    obj.item.numArray = []
    obj.item.quantity = 2
    for (let i = start; i <= obj.item.maxQuantity; i++) {
        obj.item.numArray.push(i)
    }
    obj.item.quantityFlg = true
}

function setUnit(obj, num) {
    obj.item.quantity = num
    obj.item.quantityFlg = false
    obj.item.numArray = []
}

function setSmallItemUnit(obj, num) {
  obj.item.smallItemQuantity = num
  obj.item.smallItemMumArray = []
}

function submitSmallItems(obj, path) {
    //エラーフラグを初期化
    obj.setErrorFlg(false)

    //台数入力チェック null→0
    obj.item.quantity = obj.item.quantity || 0
    // 選択した品目数
    let count = common.countLargeItems(obj) + obj.mediumCounts + obj.item.quantity
    // 選択がなかった場合
    if (count === 0) {
        obj.setErrorFlg(true)
        // 大型、中型の表示品目がない場合
        if (obj.largeView === 0 && obj.mediumView === 0) {
            // 表示品目が小型のみの場合、「無し」の選択肢が不要で、初期値が「1箱」となるので、エラーが発生しない
        } else if (obj.largeView === 0) {
            obj.error.no_items_without_large = true
        } else if (obj.mediumView === 0) {
            obj.error.no_items_without_medium = true
        } else {
            obj.error.no_items = true
        }
    }

    // 法人サイトの場合、回収箱数が最大値を超えていないかまたは、小数になっていないかチェック
    if(obj.siteCodeInfo[0].BIZ_FLG == '1' && (obj.item.quantity > common.constant.MAXQUANTITY_BIZ || common.isSyousuNum(obj.item.quantity))){
        obj.item.bizMaxUnitErrFlg = true
        obj.setErrorFlg(true)
    }else{
        obj.item.bizMaxUnitErrFlg = false
    }

    common.setStore(obj, 'smallTag', obj.smallTag)
    common.setStore(obj, 'numOfSmallItemsTag', obj.numOfSmallItemsTag)
    common.setStore(obj, 'smallItems', obj.item)
    common.setStore(obj, 'errorFlg', obj.errorFlg())

    common.setRoute(obj, path)
}

/**
 * 価格設定が個別、かつ中型を選択した場合
 * 「中型に同梱」選択肢を表示
 */
function getDisplayFlg() {
    return this.siteCodeInfo[0].PRICING_METHOD == 2 && this.mediumCounts > 0
}

/**
 * 価格設定が個別の場合、1つ目の選択肢に「無し」
 * 価格設定が一律の場合、1つ目の選択肢に「（中型台数）箱」
 */
function getStartNum() {
    return this.siteCodeInfo[0].PRICING_METHOD == 2 ? 0 : this.mediumCounts
}

/**
 * 1つ目選択肢の表示内容
 * 価格設定が個別の場合、「無し」を表示
 * 価格設定が一律の場合、「（中型台数）箱」を表示
 */
function getFirstChoiceContent() {
    let content = ''
    if (this.siteCodeInfo[0].PRICING_METHOD == 2 || (this.siteCodeInfo[0].PRICING_METHOD == 1 && this.mediumCounts == 0)) {
        content = '無し'
    } else {
        content = this.mediumCounts + '<span class="units">箱</span>'
    }

    return content
}

function pageBack(obj) {
    let path = ''
    if (obj.largeView === 0 && obj.mediumView === 0) {
        path = common.constant.ADDRESS_FORM_PATH
    } else if (obj.mediumView === 0) {
        path = common.constant.LARGE_ITEMS_PATH
    } else {
        path = common.constant.MEDIUM_ITEMS_PATH
    }

    common.pageBack(obj, path)
}
function unitInput(obj, item, event) {
  item.quantity = Math.max(Number(event.target.value), 0)
  item.quantityFlg = item.quantity > 1

  obj.smallTag = item.quantity > 1 ? '2':item.quantity.toString()
}
function setDefault(item) {
  item.quantityFlg = true
  item.quantity = 2
}

export default {
    common,
    inputRetention,
    createNumArray,
    setUnit,
    setSmallItemUnit,
    submitSmallItems,
    getDisplayFlg,
    getStartNum,
    getFirstChoiceContent,
    pageBack,
    unitInput,
    setDefault
}
